var map = {
	"./inst-1.png": "e017",
	"./inst-10.png": "90bd",
	"./inst-11.png": "8600",
	"./inst-12.png": "567a",
	"./inst-13.png": "d1d1",
	"./inst-14.png": "305d",
	"./inst-15.png": "3b47",
	"./inst-16.png": "4ab2",
	"./inst-17.png": "a17c",
	"./inst-18.png": "aa43",
	"./inst-2.png": "e1bf",
	"./inst-3.png": "d54a",
	"./inst-4.png": "4dfb",
	"./inst-5.png": "66d5",
	"./inst-6.png": "26a9",
	"./inst-7.png": "7703",
	"./inst-8.png": "851e",
	"./inst-9.png": "924c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c11";